import { getPremiumEssentialsSafe } from '@wix/premium-fed-sdk/@premium-essentials';
import { ExperimentSpecs } from '../constants';
export const isBmHarmonyThemeEnabled = () => {
  var _getPremiumEssentials;
  return Boolean((_getPremiumEssentials = getPremiumEssentialsSafe()) == null || (_getPremiumEssentials = _getPremiumEssentials.experiments) == null ? void 0 : _getPremiumEssentials[ExperimentSpecs.BmHarmonyTheme]);
};
//# sourceMappingURL=harmonyTheme.js.map